import angular from 'angular';
import lendingTab from './lendingTab';

export default angular
  .module('contactLendingTab.scenes.lendingTab', [])
  .component('lendingTab', lendingTab).name;
